import m from "../../geodata/es2015/indiaHigh";
window.am4geodata_indiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/indiaHigh.js
// module id = null
// module chunks = 